class LqdAccordionHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);
    
    this.handleDestroy();

    this.initAccordion();
    // this.handleSize();
    // this.handleBorders();
    // this.handleBorderRound();
    // this.handleSideSpace();
    // this.handleContentPadding();
    // this.handleBodyRound();
    // this.handleItemsShadow();
    // this.handleHeadingShadow();
    // this.handleActiveHeadingShadow();
    // this.handleExpanderPosition();
    // this.handleExpanderSize();

  }

  // onElementChange( propertyName ) {

    // if ( propertyName === 'size' ) {
    //   this.handleSize();
    // }
    // if ( propertyName === 'borders' ) {
    //   this.handleBorders();
    // }
    // if ( propertyName === 'border_round' ) {
    //   this.handleBorderRound();
    // }
    // if (
    //   propertyName === 'active_style' ||
    //   propertyName === 'heading_shadow' ||
    //   propertyName === 'items_shadow' ||
    //   propertyName === 'heading_bg_color_background' ||
    //   propertyName === 'heading_bg_color_color' ||
    //   propertyName === 'heading_active_bg_color_background' ||
    //   propertyName === 'heading_active_bg_color_color'
    // ) {
    //   this.handleSideSpace();
    // }
    // if ( propertyName === 'content_bg_color' ) {
    //   this.handleContentPadding();
    // }
    // if ( propertyName === 'body_border_round' ) {
    //   this.handleBodyRound();
    // }
    // if ( propertyName === 'items_shadow' ) {
    //   this.handleItemsShadow();
    // }
    // if ( propertyName === 'heading_shadow' ) {
    //   this.handleHeadingShadow();
    // }
    // if ( propertyName === 'active_style' ) {
    //   this.handleActiveHeadingShadow();
    // }
    // if ( propertyName === 'expander_position' ) {
    //   this.handleExpanderPosition();
    // }
    // if ( propertyName === 'expander_size' ) {
    //   this.handleExpanderSize();
    // }

  // }

  getDefaultSettings() {
    return {
      // padding: {
      //   default: {
      //     top: .93,
      //     right: 1.5,
      //     bottom: .93,
      //     left: 1.5,
      //     unit: 'em'
      //   },
      //   xs: {
      //     top: 0,
      //     bottom: 0,
      //   },
      //   sm: {
      //     top: .65,
      //     bottom: .65,
      //   },
      //   lg: {
      //     top: 1.05,
      //     bottom: 1.05,
      //   },
      //   sideSpace: {
      //     left: 1.5,
      //     right: 1.5
      //   }
      // },
      // borderRadius: {
      //   default: 0,
      //   round: 4,
      //   circle: 100,
      // },
      // expanderSizes: {
      //   default: 16,
      //   lg: 22,
      //   xl: 26,
      // },
      selectors: {
        accordionElement: '.accordion',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $accordionElement: this.$element.find(selectors.accordionElement),
    }
  }

  // getModel() {

  //   const modelCID = this.getModelCID();

  //   return elementorFrontend.config.elements.data[ modelCID ];

  // }

  // getSettingsModel() {

  //   let settings;
  //   const model = this.getModel();

  //   if ( this.isEdit && model ) {
  //     settings = model;
  //   } else {
  //     settings = this.$element.data( 'settings' ) || {};
  //   }

  //   return settings;

  // }

  // handleSize() {

  //   const padding = this.getSettings('padding');
  //   const model = this.getModel();
  //   let size = this.getSettingsModel().get('size');

  //   const pad = {
  //     top: padding.default.top,
  //     bottom: padding.default.bottom,
  //     unit: padding.default.unit,
  //   };

  //   switch (size) {
  //     case 'xs':
  //       pad.top = padding.xs.top;
  //       pad.bottom = padding.xs.bottom;
  //       break;
  //     case 'sm':
  //       pad.top = padding.sm.top;
  //       pad.bottom = padding.sm.bottom;
  //       break;
  //     case 'lg':
  //       pad.top = padding.lg.top;
  //       pad.bottom = padding.lg.bottom;
  //       break;
  //   }

  //   model.setExternalChange('accordion_heading_padding', {
  //     ...model.get('accordion_heading_padding'),
  //     top: pad.top,
  //     bottom: pad.bottom,
  //     unit: pad.unit,
  //     isLinked: false
  //   });
    
  // }

  // handleBorders() {

  //   const  padding = this.getSettings('padding');
  //   const model = this.getModel();
  //   const borders = model.get('borders');

  //   if (
  //     borders === 'accordion-title-bordered' ||
  //     borders === 'accordion-title-underlined'
  //   ) {
  //     model.setExternalChange('accordion_item_border_border', '');
  //     model.setExternalChange('accordion_item_border_color', '');
  //     model.setExternalChange('accordion_heading_border_border', 'solid');
  //     model.setExternalChange('accordion_heading_border_color', '#d8dbe2');
  //   }

  //   if (
  //     borders === 'accordion-body-underlined' ||
  //     borders === 'accordion-body-bordered'
  //   ) {
  //     model.setExternalChange('accordion_heading_border_border', '');
  //     model.setExternalChange('accordion_heading_border_color', '');
  //     model.setExternalChange('accordion_item_border_border', 'solid');
  //     model.setExternalChange('accordion_item_border_color', '#e0e1eb');
  //   }

  //   if (
  //     ( borders === 'accordion-title-underlined' ||
  //     borders === 'accordion-body-underlined' )
  //     &&
  //     (model.get('active_style') !== 'yes' &&
	// 		model.get('items_shadow') !== 'yes' &&
	// 		model.get('heading_bg_color_color') === '' &&
	// 		model.get('heading_active_bg_color_color') === '')
  //   ) {
  //     model.setExternalChange('accordion_heading_padding', {
  //       ...model.get('accordion_heading_padding'),
  //       left: 0,
  //       right: 0,
  //       isLinked: false
  //     });
  //     model.setExternalChange('content_padding', {
  //       ...model.get('content_padding'),
  //       left: 0,
  //       right: 0,
  //       isLinked: false
  //     });
  //   }

  //   if (
  //     borders === 'accordion-title-bordered' ||
  //     borders === 'accordion-body-bordered'
  //   ) {
  //     model.setExternalChange('accordion_heading_padding', {
  //       ...model.get('accordion_heading_padding'),
  //       left: padding.sideSpace.left,
  //       right: padding.sideSpace.right,
  //       isLinked: false
  //     });
  //     model.setExternalChange('content_padding', {
  //       ...model.get('content_padding'),
  //       left: padding.sideSpace.left,
  //       right: padding.sideSpace.right,
  //       isLinked: false
  //     });
  //   }

  //   if ( borders === 'accordion-title-bordered' ) {
  //     model.setExternalChange('accordion_heading_border_width', {
  //       ...model.get('accordion_heading_border_width'),
  //       bottom: 1,
  //       left: 1,
  //       right: 1,
  //       top: 1,
  //       isLinked: true
  //     });
  //   }

  //   if ( borders === 'accordion-title-underlined' ) {
  //     model.setExternalChange('accordion_heading_border_width', {
  //       ...model.get('accordion_heading_border_width'),
  //       bottom: 1,
  //       left: 0,
  //       right: 0,
  //       top: 0,
  //       isLinked: false
  //     });
  //     model.setExternalChange('accordion_heading_border_radius', {
  //       ...model.get('accordion_heading_border_radius'),
  //       bottom: 0,
  //       left: 0,
  //       right: 0,
  //       top: 0,
  //     });
  //     model.setExternalChange('accordion_active_heading_border_radius', {
  //       ...model.get('accordion_active_heading_border_radius'),
  //       bottom: 0,
  //       left: 0,
  //       right: 0,
  //       top: 0,
  //     });
  //   }
    
  //   if ( borders === 'accordion-body-underlined' ) {
  //     model.setExternalChange('accordion_item_border_width', {
  //       ...model.get('accordion_item_border_width'),
  //       bottom: 1,
  //       left: 0,
  //       right: 0,
  //       top: 0,
  //       isLinked: false
  //     });
  //   }
    
  //   if ( borders === 'accordion-body-bordered' ) {
  //     model.setExternalChange('accordion_item_border_width', {
  //       ...model.get('accordion_item_border_width'),
  //       bottom: 1,
  //       left: 1,
  //       right: 1,
  //       top: 1,
  //       isLinked: true
  //     });
  //   }

  //   if ( borders === '' ) {
  //     model.setExternalChange('accordion_item_border_border', '');
  //     model.setExternalChange('accordion_item_border_color', '');
  //     model.setExternalChange('accordion_heading_border_border', '');
  //     model.setExternalChange('accordion_heading_border_color', '');
      
  //     model.setExternalChange('accordion_item_border_width', {
  //       ...model.get('accordion_item_border_width'),
  //       bottom: '',
  //       left: '',
  //       right: '',
  //       top: '',
  //       isLinked: true
  //     });
  //     model.setExternalChange('accordion_heading_border_width', {
  //       ...model.get('accordion_heading_border_width'),
  //       bottom: '',
  //       left: '',
  //       right: '',
  //       top: '',
  //       isLinked: true
  //     });
  //     model.setExternalChange('accordion_heading_border_radius', {
  //       ...model.get('accordion_heading_border_radius'),
  //       bottom: '',
  //       left: '',
  //       right: '',
  //       top: '',
  //       isLinked: true
  //     });
  //     model.setExternalChange('accordion_active_heading_border_radius', {
  //       ...model.get('accordion_active_heading_border_radius'),
  //       bottom: '',
  //       left: '',
  //       right: '',
  //       top: '',
  //       isLinked: true
  //     });
  //   }


  // }

  // handleBorderRound() {

  //   const br = this.getSettings('borderRadius');
  //   const model = this.getModel();
  //   let borderRound = this.getSettingsModel().get('border_round');
  
  //   switch (borderRound) {
  //     case 'accordion-title-round':
  //       borderRound = br.round;
  //       break;
  //     case 'accordion-title-circle':
  //       borderRound = br.circle;
  //       break;
  //     default:
  //       borderRound = br.default;
  //       break;
  //   }

  //   model.setExternalChange('accordion_heading_border_radius', {
  //     ...model.get('accordion_heading_border_radius'),
  //     top: borderRound,
  //     right: borderRound,
  //     bottom: borderRound,
  //     left: borderRound,
  //   });
  //   model.setExternalChange('accordion_active_heading_border_radius', {
  //     ...model.get('accordion_active_heading_border_radius'),
  //     top: borderRound,
  //     right: borderRound,
  //     bottom: borderRound,
  //     left: borderRound,
  //   });

  // }

  // handleSideSpace() {
    
  //   const padding = this.getSettings('padding');
  //   const model = this.getModel();
    
  //   if (
  //     model.get('active_style') === 'yes' ||
	// 		model.get('heading_shadow') === 'yes' ||
	// 		model.get('items_shadow') === 'yes' ||
	// 		model.get('heading_bg_color_background') !== '' ||
	// 		model.get('heading_bg_color_color') !== '' ||
	// 		model.get('heading_active_bg_color_background') !== '' ||
	// 		model.get('heading_active_bg_color_color') !== ''
  //   ) {
      
  //     model.setExternalChange('accordion_heading_padding', {
  //       ...model.get('accordion_heading_padding'),
  //       left: padding.sideSpace.left,
  //       right: padding.sideSpace.right,
  //       isLinked: false
  //     });
      
  //   } else {
      
  //     model.setExternalChange('accordion_heading_padding', {
  //       ...model.get('accordion_heading_padding'),
  //       left: 0,
  //       right: 0,
  //       isLinked: false
  //     });

  //   }

  // }

  // handleContentPadding() {
      
  //   const padding = this.getSettings('padding');
  //   const model = this.getModel();
  //   const bg = model.get('content_bg_background');
  //   const bgColor = model.get('content_bg_color');
    
  //   if ( bg !== '' || bgColor !== '' ) {
      
  //     model.setExternalChange('content_padding', {
  //       ...model.get('content_padding'),
  //       left: padding.sideSpace.left,
  //       right: padding.sideSpace.right,
  //       isLinked: false
  //     });

  //   } else {

  //     model.setExternalChange('content_padding', {
  //       ...model.get('content_padding'),
  //       left: '',
  //       right: '',
  //       isLinked: false
  //     });

  //   }
  
  // }

  // handleBodyRound() {

  //   const borderRadius = this.getSettings('borderRadius');
  //   const model = this.getModel();
  //   const bodyRound = model.get('body_border_round');

  //   if ( bodyRound === 'accordion-body-round' ) {

  //     model.setExternalChange('accordion_item_border_radius', {
  //       ...model.get('accordion_item_border_radius'),
  //       top: borderRadius.round,
  //       right: borderRadius.round,
  //       bottom: borderRadius.round,
  //       left: borderRadius.round,
  //     });

  //   } else if ( bodyRound === '' ) {

  //     model.setExternalChange('accordion_item_border_radius', {
  //       ...model.get('accordion_item_border_radius'),
  //       top: '',
  //       right: '',
  //       bottom: '',
  //       left: '',
  //     });

  //   }

  // }

  // handleItemsShadow() {
    
  //   const model = this.getModel();
  //   const itemsShadow = model.get('items_shadow');

  //   if ( itemsShadow === 'yes' ) {
  //     model.setExternalChange('accordion_item_boxshadow_box_shadow_type', 'yes');
  //     model.setExternalChange('accordion_item_boxshadow_box_shadow', {
  //       ...model.get('accordion_item_boxshadow_box_shadow'),
  //       horizontal: 0,
  //       vertical: 0,
  //       blur: 15,
  //       color: 'rgba(0, 0, 0, 0.05)'
  //     });
  //   } else {
  //     model.setExternalChange('accordion_item_boxshadow_box_shadow_type', '');
  //   }

  // }

  // handleHeadingShadow() {
    
  //   const model = this.getModel();
  //   const headingShadow = model.get('heading_shadow');

  //   if ( headingShadow === 'yes' ) {
  //     model.setExternalChange('accordion_heading_boxshadow_box_shadow_type', 'yes');
  //     model.setExternalChange('accordion_heading_boxshadow_box_shadow', {
  //       ...model.get('accordion_heading_boxshadow_box_shadow'),
  //       horizontal: 0,
  //       vertical: 22,
  //       blur: 70,
  //       color: 'rgba(0, 0, 0, 0.08)'
  //     });
  //   } else {
  //     model.setExternalChange('accordion_heading_boxshadow_box_shadow_type', '');
  //   }

  // }

  // handleActiveHeadingShadow() {
    
  //   const model = this.getModel();
  //   const activeStyle = model.get('active_style');

  //   if ( activeStyle === 'yes' ) {
  //     model.setExternalChange('accordion_active_heading_boxshadow_box_shadow_type', 'yes');
  //     model.setExternalChange('accordion_active_heading_boxshadow_box_shadow', {
  //       ...model.get('accordion_active_heading_boxshadow_box_shadow'),
  //       horizontal: 0,
  //       vertical: 22,
  //       blur: 70,
  //       color: 'rgba(0, 0, 0, 0.08)'
  //     });
  //   } else {
  //     model.setExternalChange('accordion_active_heading_boxshadow_box_shadow_type', '');
  //   }

  // }

  // handleExpanderPosition() {

    // const model = this.getModel();
    // const padding = this.getSettings('padding');
    // const position = model.get('expander_position');

    // if ( position === 'accordion-expander-left' ) {
    //   model.setExternalChange('accordion_heading_padding', {
    //     ...model.get('accordion_heading_padding'),
    //     left: padding.sideSpace.left * 1.25,
    //     isLinked: false
    //   });
    // } else {
    //   model.setExternalChange('accordion_heading_padding', {
    //     ...model.get('accordion_heading_padding'),
    //     left: '',
    //     isLinked: false
    //   });
    // }

  // }

  // handleExpanderSize() {

  //   const model = this.getModel();
  //   const size = model.get('expander_size');
  //   const expanderSizes = this.getSettings('expanderSizes');

  //   if ( size === 'accordion-expander-lg' ) {
  //     model.setExternalChange('expander_size_slider', {
  //       ...model.get('expander_size_slider'),
  //       size: expanderSizes.lg
  //     });
  //   } else if ( size === 'accordion-expander-xl' ) {
  //     model.setExternalChange('expander_size_slider', {
  //       ...model.get('expander_size_slider'),
  //       size: expanderSizes.xl
  //     });
  //   }

  // }

  initAccordion() {

    this.elements.$accordionElement.liquidAccordion();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleAccordionDestroy();

  }

  handleAccordionDestroy() {

    if ( ! this.elements.$accordionElement.length ) return;

    const accordionData = this.elements.$accordionElement.data('plugin_liquidAccordion');

    if ( accordionData ) {
      accordionData.destroy();
    }

  }
  
}


export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdAccordionHandler, { $element } );
};